import { createContext } from "react";

import type { useKioskOverview } from "./use-kiosk-overview";

export type KioskContext = ReturnType<typeof useKioskOverview>;
export const KioskContext = createContext<KioskContext | undefined>(undefined);
